import React, { useEffect, useState } from 'react';
import { getApiBaseUrl } from "../utils/apiAssetUrl";
import '../CSS/Global.css';
import { useNavigate } from 'react-router-dom';
import productadd from "../Images/productadd.png"
import { Spinner, useToast } from '@chakra-ui/react';
import { validateImageFileForUpload, IMAGE_ACCEPT_ATTR, IMAGE_TYPES_HELPER_TEXT } from "../utils/imageUploadRules";
import LocationProductDetailsForm from "./LocationProductDetailsForm";
import { resolveIsLocationCategory } from "../utils/locationCategory";
import {
  getDefaultLocationDetails,
  getListingTokenAmountFromStore,
  validateLocationDetailsClient,
} from "../utils/locationProductDetails";

const MAX_PRODUCT_PHOTOS = 10;

function appendLocationDocsToFormData(formData, docFiles) {
  const map = {
    noc: "location_doc_noc",
    business_license: "location_doc_business_license",
    fire_safety: "location_doc_fire_safety",
    local_authority: "location_doc_local_authority",
    insurance: "location_doc_insurance",
  };
  Object.entries(map).forEach(([k, field]) => {
    const f = docFiles[k];
    if (f instanceof File) formData.append(field, f);
  });
}

const AddProduct = () => {
  const [productName, setProductName] = useState('');
  const [mrp, setMrp] = useState('');
  const [sellingPrice, setSellingPrice] = useState('');
  const [shortDescription, setShortDescription] = useState('');
  const [imageFiles, setImageFiles] = useState([]);
  const login = JSON.parse(localStorage.getItem("login")) || ""
  let navigate = useNavigate()
  const [units, setUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState('');
  const [quantity, setSelectedQuantity] = useState('');
  const toast = useToast()
  const [load, setLoad] = useState(true);
  const [showAdditional, setShowAdditional] = useState(false);
  const [shiftHour, setShiftHour] = useState('');
  const [storeSnapshot, setStoreSnapshot] = useState(null);
  const [isLocationCategory, setIsLocationCategory] = useState(false);
  const [locationDetails, setLocationDetails] = useState(() => getDefaultLocationDetails());
  const [locationDocFiles, setLocationDocFiles] = useState({});

  const tokenAmount = getListingTokenAmountFromStore(storeSnapshot);

  const handleImageUpload = async (event) => {
    const files = Array.from(event.target.files || []);
    event.target.value = "";
    if (!files.length) return;

    const remaining = MAX_PRODUCT_PHOTOS - imageFiles.length;
    if (remaining <= 0) {
      toast({
        title: "Maximum photos reached",
        description: `You can upload up to ${MAX_PRODUCT_PHOTOS} photos per product.`,
        status: "warning",
        duration: 5000,
        isClosable: true,
        position: "top",
      });
      return;
    }

    const toAdd = [];
    for (const file of files.slice(0, remaining)) {
      const r = await validateImageFileForUpload(file);
      if (!r.ok) {
        toast({
          title: "Invalid image",
          description: r.message,
          status: "error",
          duration: 6000,
          isClosable: true,
          position: "top",
        });
        continue;
      }
      toAdd.push(r.file);
    }
    if (toAdd.length) {
      setImageFiles((prev) => [...prev, ...toAdd].slice(0, MAX_PRODUCT_PHOTOS));
    }
  };

  const removeImageAt = (index) => {
    setImageFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const mrpNum = parseFloat(mrp);
    const sellingPriceNum = parseFloat(sellingPrice);
    if (mrp && sellingPrice && sellingPriceNum > mrpNum) {
      toast({
        description: 'Selling Price cannot be more than MRP',
        status: 'error',
        duration: 5000,
        position: 'top-center',
        isClosable: true,
      });
      return;
    }

    if (isLocationCategory) {
      const check = validateLocationDetailsClient(locationDetails, tokenAmount);
      if (!check.ok) {
        toast({
          title: "Location details",
          description: check.message,
          status: "error",
          duration: 6000,
          isClosable: true,
        });
        return;
      }
    }

    setLoad(false);
    const formData = new FormData();
    imageFiles.forEach((file) => formData.append('product_images', file));
    formData.append('product_name', productName);
    formData.append('mrp_price', mrp);
    formData.append('sell_price', sellingPrice);
    formData.append('quantity', quantity);
    formData.append('unit', selectedUnit);
    formData.append('description', shortDescription);
    formData.append('user_id', login.permanent_ID);
    formData.append('user_name', login.name);
    formData.append('shift_hour', shiftHour);
    formData.append('type', 'product');

    if (isLocationCategory) {
      formData.append("location_details", JSON.stringify(locationDetails));
      formData.append("listing_token_amount", String(tokenAmount));
      appendLocationDocsToFormData(formData, locationDocFiles);
    } else {
      formData.append("clear_location_details", "1");
    }

    try {
      const response = await fetch(`${getApiBaseUrl()}/product/add-product/${login.permanent_ID}`, {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();
      console.log('Image uploaded:', result);
      if (response.ok) {
        toast({
          description: `Product added successfully`,
          status: 'success',
          duration: 5000,
          position: 'top-center',
          isClosable: true,
        });
        navigate(-1)
        setLoad(true)
      } else {
        toast({
          title: "Could not add product",
          description: result?.error || result?.message || 'Request failed',
          status: 'error',
          duration: 6000,
          isClosable: true,
        });
        setLoad(true);
      }
    } catch (error) {
      console.log('Error uploading image:', error);
      setLoad(true)
    }
  };

  const [category, setCategory] = useState();

  const fetchDataUser = async () => {
    try {
      const response = await fetch(`${getApiBaseUrl()}/store/getstorelist/mystore/${login.permanent_ID}`);
      const store = await response.json();
      console.log(store);
      setStoreSnapshot(store);
      setCategory(store.category);
      const api = getApiBaseUrl();
      const isLoc = await resolveIsLocationCategory(api, store.category, store.subcategory);
      setIsLocationCategory(isLoc);
    } catch (error) {
      console.log(error);
    }
  }

  const fetchCategory = async () => {
    try {
      const response = await fetch(`${getApiBaseUrl()}/category/singlecategory/${category}`);
      const res = await response.json();
      console.log(res);

      if (res.units) {
        const parsedUnits = JSON.parse(res.units);
        console.log('Parsed Units:', parsedUnits);
        setUnits(parsedUnits);
      } else {
        console.log('Units field is not available');
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (category) {
      fetchCategory();
    }
  }, [category]);


  useEffect(() => {
    fetchDataUser();
  }, []);

  useEffect(() => {
    if (!isLocationCategory) {
      setLocationDetails(getDefaultLocationDetails());
      setLocationDocFiles({});
    }
  }, [isLocationCategory]);

  const hours = Array.from({ length: 24 }, (_, i) => {
    const value = i + 1;
    return {
      value: value,
      label: value.toString().padStart(2, '0') + ' hrs'
    };
  });

  console.log(selectedUnit);


  return (
    <div className="product-container">
      <div className="product-image-column">
        <img
          src={productadd}
          alt="Product"
          className="product-image"
        />
      </div>
      <div className="product-form-column">
        <h2>List Your Product/Skills/Service</h2>
        <form onSubmit={handleSubmit}>
          <div className="product-form-group">
            <label>Title:</label>
            <input
              type="text"
              value={productName}
              onChange={(e) => setProductName(e.target.value)}
              placeholder="Enter title"
              required
            />
          </div>
          <div className="product-form-group">
            <label>Upload images (optional, up to {MAX_PRODUCT_PHOTOS}):</label>
            <input
              type="file"
              accept={IMAGE_ACCEPT_ATTR}
              multiple
              onChange={handleImageUpload}
              disabled={imageFiles.length >= MAX_PRODUCT_PHOTOS}
            />
            <p className="small text-muted" style={{ marginTop: 6 }}>{IMAGE_TYPES_HELPER_TEXT}</p>
            <p className="small text-muted" style={{ marginTop: 4 }}>
              {imageFiles.length} / {MAX_PRODUCT_PHOTOS} selected — first image is the main card thumbnail.
            </p>
            {imageFiles.length > 0 && (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 10 }}>
                {imageFiles.map((file, idx) => (
                  <div key={`${file.name}-${idx}`} style={{ position: 'relative', width: 72, height: 72 }}>
                    <img
                      src={URL.createObjectURL(file)}
                      alt=""
                      style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 8 }}
                    />
                    <button
                      type="button"
                      onClick={() => removeImageAt(idx)}
                      aria-label="Remove"
                      style={{
                        position: 'absolute',
                        top: -6,
                        right: -6,
                        width: 22,
                        height: 22,
                        borderRadius: '50%',
                        border: 'none',
                        background: 'var(--red, #c53030)',
                        color: '#fff',
                        cursor: 'pointer',
                        fontSize: 12,
                        lineHeight: 1,
                      }}
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="product-form-group">
            <label>Short Description (max 50 chars):</label>
            <input
              type="text"
              value={shortDescription}
              onChange={(e) => setShortDescription(e.target.value)}
              maxLength="50"
              placeholder="Enter short description"
              required
            />
          </div>
          <div className="product-form-group">
            <label style={{ fontWeight: "600" }}>Additional Details</label>
            <div
              onClick={() => setShowAdditional(!showAdditional)}
              className="toggle-btn"
              style={{
                width: "60px",
                height: "30px",
                background: showAdditional ? "var(--red)" : "#ccc",
                borderRadius: "20px",
                cursor: "pointer",
                position: "relative",
                transition: "0.3s",
                marginBottom: "10px"
              }}
            >
              <div
                style={{
                  width: "26px",
                  height: "26px",
                  background: "#fff",
                  borderRadius: "50%",
                  position: "absolute",
                  top: "2px",
                  left: showAdditional ? "32px" : "2px",
                  transition: "0.3s"
                }}
              ></div>
            </div>
          </div>

          {showAdditional && (
            <div className="additional-section" style={{
              padding: "15px",
              background: "#fff",
              borderRadius: "10px",
              marginBottom: "15px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
            }}>
              <div className="product-form-group">
                <label>Hourly Shift:</label>
                <select
                  className="bestselecttagforec"
                  value={shiftHour}
                  onChange={(e) => setShiftHour(e.target.value)}
                >
                  <option value="">Select Hours</option>
                  {hours.map((hour) => (
                    <option key={hour.value} value={hour.value}>
                      {hour.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="price-container">

                <div className="product-form-group">
                  <label>Unit:</label>
                  <select
                    className="bestselecttagforec"
                    value={selectedUnit}
                    onChange={(e) => setSelectedUnit(e.target.value)}
                  >
                    <option value="">Select Unit</option>
                    {units.map((unit, index) => (
                      <option key={index} value={unit}>
                        {unit}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="product-form-group">
                  <label>
                    Quantity/Value{" "}
                    {selectedUnit ? `(${selectedUnit})` : ""}
                  </label>

                  <input
                    type="number"
                    value={quantity}
                    onChange={(e) => setSelectedQuantity(e.target.value)}
                    placeholder={selectedUnit ? `Enter Value in ${selectedUnit}` : "Enter Value"}
                  />
                </div>

              </div>

              <div className="price-container">

                <div className="product-form-group">
                  <label>MRP:</label>
                  <input
                    type="number"
                    value={mrp}
                    onChange={(e) => setMrp(e.target.value)}
                    placeholder="Enter MRP"
                  />
                </div>

                <div className="product-form-group">
                  <label>Selling Price:</label>
                  <input
                    type="number"
                    value={sellingPrice}
                    onChange={(e) => setSellingPrice(e.target.value)}
                    placeholder="Enter Selling Price"
                    max={mrp || undefined}
                  />
                  {mrp && sellingPrice && parseFloat(sellingPrice) > parseFloat(mrp) && (
                    <span style={{ color: 'var(--red)', fontSize: '12px', marginTop: '4px', display: 'block' }}>
                      Selling Price cannot be more than MRP
                    </span>
                  )}
                </div>

              </div>

            </div>
          )}

          {isLocationCategory ? (
            <LocationProductDetailsForm
              value={locationDetails}
              onChange={setLocationDetails}
              tokenAmount={tokenAmount}
              onDocFile={(key, file) =>
                setLocationDocFiles((prev) => {
                  const next = { ...prev };
                  if (file) next[key] = file;
                  else delete next[key];
                  return next;
                })
              }
            />
          ) : null}

          {
            load ? <button type="submit" className="product-submit-button">Add</button> :
              <button className="product-submit-button"><Spinner /></button>
          }
        </form>
      </div>
    </div>
  );
};

export default AddProduct;
